import request from '@/utils/request'
import settings from '@/settings'

const SHOP_ROUTE = settings.shopRoute

export function findEnumConstant() {
    return request({
        url: `${SHOP_ROUTE}/enum-constant/findEnumConstant`,
        method: 'get'
    })
}
